import greenHouse from '../../utils/greenHouse';
import './GreenHouseIFrame.css';

type GreenHouseIFrameProps = {
  page: string;
};

const GreenHouseIFrame = ({ page }: GreenHouseIFrameProps) => {
  const isCareersPage = page === greenHouse.pages.CAREERS;
  const iFrameWrapperStyles = isCareersPage ? 'iframe-careers' : 'iframe-job-post';

  return (
    <div id="grnhse_app" className={iFrameWrapperStyles}>
      <iframe
        id="grnhse_iframe"
        width="100%"
        frameBorder={0}
        scrolling="no"
        allow="geolocation"
        title="Greenhouse Job Board"
        src="https://boards.greenhouse.io/embed/job_board?for=fabfitfun"
        height={4480}
      />
    </div>
  );
};

export default GreenHouseIFrame;
